import React, { createContext, useContext, useEffect, useState } from "react"; // Import React and hooks
import { Urls } from "./Urls"; // Import URLs from Urls file
import { auth } from "./Components/firebase/firebase"; // Import auth object from Firebase setup
import Axios from "./Axios"; // Import Axios instance

// Create a context for user details
export const UserDetailsContext = createContext({});

// Provider component to manage and provide user details
export const UserDetailsProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState({}); // State to store user details

  useEffect(() => {
    // Fetch user details when component mounts
    if(auth && auth.currentUser && auth.currentUser.getIdToken()){
        Axios.get(Urls.GetCurrentUser) // Make GET request to fetch user details
        .then(res => {
            // Store user details and user ID in localStorage
            localStorage.setItem('user_id', res.data.user_details.user_id)
            localStorage.setItem('userdetails', res?.data?.user_details?.name)
            localStorage.setItem('user_name', res?.data?.user_details?.name)
            setUserDetails(res.data)
            // Check if user has multiple emails or a single email and store accordingly
            if (res.data.user_details.emails && res.data.user_details.emails.length > 0) {
              localStorage.setItem("useremail", res.data.user_details.emails);
            }
            else {
              localStorage.setItem("useremail", res.data.user_details.email);
            }
        })
        .catch(err => console.log(err)) // Handle errors
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <UserDetailsContext.Provider value={[userDetails, setUserDetails]}>
      {children} {/* Render child components with user details context */}
    </UserDetailsContext.Provider>
  );
};

// Custom hook to use user details context
export function useUser(){
  return useContext(UserDetailsContext)
}
